import React, { useEffect, useState } from "react";
import Header from "../../../layouts/Header";
import image1 from "../../../assets/images/image1.svg";
import image3 from "../../../assets/images/image3.svg";
import image4 from "../../../assets/images/image4.svg";
import CutImage2 from "../../../assets/images/CutImage2.png";
import "../../../assets/styles/local/PageNotFound.css";

const PageNotFound = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1500);
  });

  return (
    <>
      <Header />
      <div className="mainDiv">
        <div className="image1">
          <img src={image1} alt="" className="image1size" />
        </div>

        <div className="ASC">
          <div className="OopDiv">
            <div className="d-flex oopsSection">
              <img src={image3} alt="" className="image3size" />
              <p>
                <span className="circleText">O</span>
                <span className="circleText">O</span>
                <span className="psText">ps...</span>
              </p>
            </div>

            <div className="image4">
              <img src={image4} alt="" className="image4size" />
            </div>

            <div className="d-flex pt-2 pageNotFoundSection">
              <p>Page not found</p>
            </div>

            <br></br>
            <div className="textSection pt-2">
              <p>It seems we are not able to find the</p>
            </div>

            <div className="text2Section pt-2">
              <p>page you are looking for.</p>
            </div>

            <div className="text3Section pt-2">
              <p> Please try again later or change</p>
            </div>

            <div className="text4Section pt-2">
              <p>the search criteria.</p>
            </div>
          </div>
        </div>

        <div className="www">
          <div className="halfimgDiv">
            <img src={CutImage2} alt="" className="CutImage" />
          </div>
        </div>
      </div>
    </>
  );
};

export default PageNotFound;
